import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { showAdventHint, adventOpenDay } from "@/lib/advent";
import { useLang } from "@/i18n";
import teaserAsset from "@/assets/adventkalender-teaser-klein.webp.asset.json";

const AdventHint = () => {
  const lang = useLang();
  if (lang !== "de" || !showAdventHint(new Date())) return null;
  return (
    <div className="container mx-auto px-4 pt-6">
      <Link to="/adventkalender" className="flex items-center justify-center gap-3 rounded-full border border-primary/30 bg-secondary pl-2 pr-5 py-2 text-sm text-foreground hover:border-primary transition-colors">
        <img
          src={teaserAsset.url}
          alt="Adventkalender – tolle Gewinnse warten auf dich"
          loading="lazy"
          width={52}
          height={52}
          className="w-[52px] h-[52px] rounded-full object-cover shrink-0"
        />
        <span className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-primary shrink-0" />
          <span><strong>Adventkalender{adventOpenDay(new Date()) === 0 ? " ab 1. Dezember" : ""}:</strong> Täglich ein Impuls zum Nie-Aufgeben – und elf Geschenke im Lostopf.</span>
        </span>
      </Link>
    </div>
  );
};

export default AdventHint;
